import { Helmet } from "react-helmet-async";

export default function LocalBusinessSchema() {
    const baseUrl = process.env.REACT_APP_SITE_URL;
    const ogImage = process.env.REACT_APP_OG_IMAGE_URL;

    const schema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "Groupe DLA",
      image: ogImage,
      "@id": baseUrl,
      url: baseUrl,
      telephone: "+1-819-523-6030",
      address: {
        "@type": "PostalAddress",
        streetAddress: "575 Rue Commerciale",
        addressLocality: "La Tuque",
        addressRegion: "QC",
        postalCode: "G9X 3A7",
        addressCountry: "CA",
      },
      areaServed: "Québec",
    };
  
    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
    );
  }